import { render, staticRenderFns } from "./PhoneRegister.vue?vue&type=template&id=b1a8ab70&scoped=true&"
import script from "./PhoneRegister.vue?vue&type=script&lang=js&"
export * from "./PhoneRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhoneRegister.vue?vue&type=style&index=0&id=b1a8ab70&prod&lang=scss&"
import style1 from "./PhoneRegister.vue?vue&type=style&index=1&id=b1a8ab70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8ab70",
  null
  
)

export default component.exports